import { Box, Container, Typography } from '@mui/material';
import * as React from 'react';

export const HistoryTopPanel = () => {
  return (
    <Box
      sx={{
        pt: { xs: 8, md: 12 },
        pb: { xs: 4, md: 8 },
      }}
    >
      <Container sx={{ pb: 0 }}>
        <Box sx={{ px: 0 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '28px', md: '32px' }
            }}
          >
            Transaction history
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
